<div class="flex">
  <i
    class="pi filter-clear-icon"
    [class.pi-filter]="!isActive"
    [class.pi-filter-fill]="isActive"
    (click)="onIconClick($event); $event.stopPropagation()"
  ></i>
  <span class="filter-repr">{{ filterRepr$ | async }}</span>
</div>

<ng-template #formTemplate>
  <form [formGroup]="filterForm">
    <div class="form-outer">
      <div class="flex justify-content-between mb-3">
        <p-dropdown
          #matchModeDropdown
          formControlName="matchMode"
          [style]="{ width: '120px' }"
          [options]="floatFilterOptions"
        ></p-dropdown>
        <i class="pi pi-filter-slash filter-clear-icon" (click)="resetFilter()"></i>
      </div>
      <div class="flex">
        <input pInputText type="text" placeholder="..." formControlName="floatFrom" [style]="{ width: '100%' }" />
        <span *ngIf="matchModeDropdown.value === 'BETWEEN'" class="align-self-center m-2">-</span>
        <input
          *ngIf="matchModeDropdown.value === 'BETWEEN'"
          pInputText
          type="text"
          placeholder="..."
          formControlName="floatTo"
          [style]="{ width: '100%' }"
        />
      </div>
    </div>
  </form>
</ng-template>

<p-overlayPanel #op appendTo="body">
  <ng-template pTemplate>
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </ng-template>
</p-overlayPanel>

<p-dialog [header]="header" [(visible)]="showDialog" modal="true" appendTo="body">
  <div style="width: 250px">
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </div>
</p-dialog>
